import { render, staticRenderFns } from "./RealTimePre.vue?vue&type=template&id=15d97ff2&"
import script from "./RealTimePre.vue?vue&type=script&lang=js&"
export * from "./RealTimePre.vue?vue&type=script&lang=js&"
import style0 from "./RealTimePre.vue?vue&type=style&index=0&id=15d97ff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports